import { ExportMetadata } from './export-metadata.model';

export class ExportMetadataSet {
  constructor(
    public name: string,
    public comments: string,
    public metadata: ExportMetadata[],
    public title?: string
  ) {}

  static adapt(item: any): ExportMetadataSet {
    return new ExportMetadataSet(
      item.name,
      item.comments,
      item.metadata.map(ExportMetadata.adapt),
      item.title
    );
  }
}
